export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    var parallaxBG = document.querySelector('.parallax-slow');
    var parallaxContent = document.querySelector('.parallax-med');

    function setTranslate(xPos, yPos, el) {
      el.style.transform = 'translate3d(' + xPos + ', ' + yPos + 'px, 0)';
    }

    window.addEventListener('DOMContentLoaded', scrollLoop, false);

    var yScrollPosition;

    function scrollLoop() {
      yScrollPosition = window.scrollY;

      setTranslate(0, yScrollPosition * 0, parallaxBG);
      setTranslate(0, yScrollPosition * -0.2, parallaxContent);

      requestAnimationFrame(scrollLoop);
    }

    // Accordion
    var menu_header = $('.menu-header');
    var collapse = $('.collapse');

    // Accordion collapse function
    $('.menu-header').click(function () {
      $(this).parent().find(collapse).slideToggle();
      $(menu_header).data('clicked', true);

      $(this).parent().siblings().children().next().slideUp();
    });


    // JavaScript to be fired on all pages, after page specific JS is fired
    $('.mega-menu-toggle').on('click', function() {
      if($('.mega-menu-toggle').hasClass('mega-menu-open')) {
        $('#mega-menu-primary_navigation').removeClass('is-active');
        $('#mega-menu-primary_navigation').contents('img').remove();
        $('#mega-menu-primary_navigation').contents('.social-media').remove();
      } else {
          $('#mega-menu-primary_navigation').addClass('is-active');

          /* This check is needed to prevent the bug which results in multiple logos being shown */
          var numberOfLogosInHeader = ($('#mega-menu-primary_navigation').html().match(/tom-craddock-logo/g) || []).length;
          var numberOfSocialInHeader = ($('#mega-menu-primary_navigation').html().match(/facebook/g) || []).length;

          if (numberOfLogosInHeader === 0) {
              $('#mega-menu-primary_navigation').prepend('<a href="/"><img src="/wp-content/uploads/2020/04/tom-craddock-logo.svg" class="mx-auto mb-2" style="width: 125px; height: 125px;" /></a>');
          }

          if (numberOfSocialInHeader === 0) {
              $('#mega-menu-primary_navigation').append('' +
                  '<div class="social-media d-xl-none d-flex justify-content-center w-100">\n' +
                  ' <a href="https://www.facebook.com/tomcraddockFA" target="_blank"><i class="fa fa-facebook-official" aria-hidden="true"></i></a>\n\n' +
                  ' <a href="https://www.instagram.com/tomcraddockFA/" target="_blank"><i class="fa fa-instagram" aria-hidden="true"></i></a>\n\n' +
                  ' <a href="https://twitter.com/tomcraddockFA" target="_blank"><i class="fa fa-twitter" aria-hidden="true"></i></a>\n' +
                  '</div>');
          }
      }
    });
  },
};





// WEBPACK FOOTER //
// ./scripts/routes/common.js